// extracted by mini-css-extract-plugin
export default {"form-container":"UserForm_form-container__u2fkd","input-container":"UserForm_input-container__6hvy0"};